export default {
  "name": "It is right here II",
  "slug": "it-is-right-here-ii",
  "path": "/it-is-right-here-ii",
  "componentName" : "ItIsRightHereIi",
  "category": "Projects",
  "parent": "Perspective Lessons",
  "isPublic": true
}